<div class="card-body">
    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="messError">
        <span>{{ messError }}</span>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="col-sm-12 d-flex justify-content-between mt-4">
        <div class="col-sm-4">
            <SelectNormal
                    :label="dataPartner.partner_id.label"
                    :id="dataPartner.partner_id.id"
                    :placeholder="dataPartner.partner_id.placeholder"
                    :value-default="dataPartner.partner_id.value"
                    @inputValue="onChangePartner($event, dataPartner.partner_id.id)"
                    :error-text="dataPartner.partner_id.error"
                    :required="dataPartner.partner_id.required"
                    @blur="validateForm($event, dataPartner.partner_id.id)"
                    :options="dataPartner.partner_id.options"
            ></SelectNormal>
        </div>
    </div>
    <div class="col-sm-12 d-flex justify-content-between mt-4">
        <div class="action d-flex align-items-center gap-3">
            <div class="total">
                {{ CommonText.TOTAL_RECORD(listDataDelivery.length, paginate.itemCount) }}
            </div>
            <div class="dropdown-action">
                <SelectNormal
                        :label="selectAction.label"
                        :id="selectAction.id"
                        :placeholder="selectAction.placeholder"
                        :value-default="selectAction.value"
                        @inputValue="onChangeAction($event)"
                        :required="selectAction.required"
                        :options="selectAction.options"
                ></SelectNormal>
            </div>
        </div>
        <div class="d-flex align-items-center gap-2">
            <span>Hiển thị</span>
            <SelectNormal
                    :label="selectLimit.label"
                    :id="selectLimit.id"
                    :placeholder="selectLimit.placeholder"
                    :value-default="selectLimit.value"
                    @inputValue="onChangeLimit($event)"
                    :required="selectLimit.required"
                    :options="selectLimit.options"
            >
            </SelectNormal>
            <span> kết quả trên trang</span>
        </div>
    </div>
    <div class="list-product-component">
        <table class="table">
            <thead>
                <tr>
                    <th>
                        <InputCheckboxOne id="select_all" :value-default="checkAll" @inputValue="onChangeSelectAll($event)"
                                          :checked="checkAll"></InputCheckboxOne>
                    </th>
                    <th class="text-center" scope="col" v-for="header in dataHeaderTable" :key="header.order"
                        :style="{ 'width': header.width }" v-html="header.label"></th>
                </tr>
            </thead>
            <tbody>
            <tr v-if="listDataDelivery.length > 0" v-for="delivery in listDataDelivery" :key="delivery.id">
                <td>
                    <InputCheckboxOne :id="delivery.delivery_code" :value-default="!!checkItems[delivery.delivery_code]"
                                      @inputValue="onChangeSelectItem($event, delivery.delivery_code)"
                                      :checked="!!checkItems[delivery.delivery_code]"></InputCheckboxOne>
                </td>
                <td class="text-center">
                    <div class="label-underline" @click="redirectToDetail(delivery.delivery_code)">{{delivery.exchange_delivery_name}}
                        <span class="tooltip">{{delivery.exchange_delivery_name}}</span>
                    </div>
                </td>
                <td class="text-center">{{ delivery.partner_name }}</td>
                <td class="text-center">{{ CommonService.formatPrice(delivery.sum_amount, 'VND') }}</td>
                <td class="text-center">{{ CommonService.formatPrice(delivery.sum_tax_amount, 'VND') }}</td>
                <td class="text-center">{{ delivery.status }}</td>
                <td class="text-center">{{ CommonService.formatDate(delivery.created_at) }}</td>
                <td class="text-center">{{ CommonService.formatDate(delivery.delivery_date) }}</td>
                <td class="text-center">{{ CommonService.formatDate(delivery.approved_date) }}</td>
            </tr>
            <tr v-else>
                <td colspan="9" class="text-center">Không có dữ lệu được tìm thấy!</td>
            </tr>
            </tbody>
        </table>
    </div>

    <PaginateComponent :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"
                       v-if="paginate.itemCount > paginate.take"></PaginateComponent>
</div>

<ModalStoreWarehouseListComponent
        @showModalStoreWarehouse="showModalStoreWarehouse($event)"
        @listStoreWarehousesSelectedCurrent="syncSelectedKiotvietDeliveries($event)"
        :typeSelectItem="typeSelectStoreWarehouse"
        :listStoreWarehousesSelected="listStoreWarehousesSelected"
        :eventClickShowModal="eventClickShowModalStoreWarehouse"
></ModalStoreWarehouseListComponent>
